export const LETTER_HISTORY_FETCHING = 'LETTER_HISTORY_FETCHING';
export const LETTER_HISTORY_FETCH_ERROR = 'LETTER_HISTORY_FETCH_ERROR';
export const LETTER_HISTORY_CLEAR_ERRORS = 'LETTER_HISTORY_CLEAR_ERRORS';

export const LETTER_HISTORY_REPORT = 'LETTER_HISTORY_REPORT';

export const LETTER_HISTORY_FETCH_STUDENTS = 'LETTER_HISTORY_FETCH_STUDENTS';
export const LETTER_HISTORY_STUDENTS_LOADING =
  'LETTER_HISTORY_STUDENTS_LOADING';
export const LETTER_HISTORY_CLEAR_STUDENTS = 'LETTER_HISTORY_CLEAR_STUDENTS';

export const LETTER_HISTORY_GET_LETTER_TEMPLATES =
  'LETTER_HISTORY_GET_LETTER_TEMPLATES';
export const LETTER_HISTORY_GET_LETTER_TEMPLATES_LOADING =
  'LETTER_HISTORY_GET_LETTER_TEMPLATES_LOADING';



// WEBPACK FOOTER //
// ./src/pages/letterhistoryreport/state/letterhistoryreport/types.js